import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler, PrimariaApi } from "@uxland/primary-shell";
import { AddHistoryItemsHandler } from "./handler";

let request: BrokerDisposableHandler;

export const bootstrapAddHistoryItems = (broker: BrokerExtensions, api: PrimariaApi) => {
  request = broker.registerRequest(api.broker.events.activityHistory.addHistoryItemsRequest, AddHistoryItemsHandler);
};

export const teardownAddHistoryItems = () => {
  request?.dispose();
};
